import React, { Component } from "react";
import { withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";

import { Dispatch } from "redux";
import { actions as soundActions } from "../../core/reducers/soundReducer";

import PIXI from "pixi.js";
import { actions as gridActions } from "../../core/reducers/gridStateReducer";
import { TIMER } from "../../core/utills";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";


interface IProps {
    [x: string]: any;


}

interface IStore {
    [x: string]: any;
}
interface IStateToProps {

}

interface IDispatchToProps {
}

interface IState {


}

class GAMESounds extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected _currentvol: number = 1;
    protected playingSound: any = [];
    protected spinSound: any = '';
    protected playScatterLandingCount: number
    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.playScatterLandingCount = 0;
    }

    playSound(stopReelId: any, nextProps: any) {

        nextProps.landingSymbolSoundArr.forEach((data: any, index: any) => {
            if (stopReelId === data.reel) {
                let soundId = ""
                if (data.symbolId === 10) {
                    soundId = "wildLandingSound"
                } else if (data.symbolId === 11) {
                    soundId = "scatterLandingSound"
                }
                // this.props.stopSound([{ name: soundId }]);
                nextProps.stopSound([{ name: "reelStoppingSound" }, { name: "wildLandingSound" }, { name: "scatterLandingSound" }]);
                nextProps.playSound([{ name: soundId, loop: false }]);
            }
        });
    }

    onButtonClickSound() {
        this.props.playSound([{ name: "genericButtonSound", loop: false }]);
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.soundIsPlaying) {


            if (nextProps.bgSoundPlay !== this.props.bgSoundPlay) {

                if (nextProps.bgSoundPlay && !nextProps.introductionScreenVisible) {


                    this.props.playSound([{ name: "bgloop", loop: true, vol: 0.4 }]);



                }
                else {

                    this.props.stopSound([{ name: "bgloop" }]);
                }
                return false;
            }

            if (nextProps.basegamestate && nextProps.basegamestate != this.props.basegamestate) {
                if (nextProps.soundIsPlaying || this.props.soundIsPlaying) {
                    nextProps.bgSoundPlay && this.props.playSound([{ name: "bgloop", loop: true }]);
                }
            }



            if (nextProps.allSpinComplete && nextProps.allSpinComplete != this.props.allSpinComplete && !nextProps.featureTriggered) {
                this.playScatterLandingCount = 0;


                let timer = TIMER.TimerManager.createTimer(200);
                timer.on('end', () => {
                    this.props.stopSound([{ name: this.spinSound }]);
                });
                timer.start();
                if (nextProps.basegamestate) {
                    nextProps.bgSoundPlay && this.props.changeVolume([{ name: "bgloop", loop: true, vol: 0.4 }]);
                } else {
                    nextProps.bgSoundPlay && this.props.changeVolume([{ name: "fgloop", loop: true, vol: 0.4 }]);
                }

            }

            if (!nextProps.showIntroductionPage && nextProps.showIntroductionPage != this.props.showIntroductionPage) {

                if (nextProps.basegamestate) {
                    // DO not play loop from here play it from sound popup yes button click
                    nextProps.bgSoundPlay && this.props.playSound([{ name: "bgloop", loop: true }]);
                } else {
                    this.props.playSound([{ name: "demoSpinSound", loop: false }]);
                }



                return false;
            }

            if (nextProps.spinStart && nextProps.spinStart !== this.props.spinStart && !nextProps.allSoundSFXStop) {
                this.props.stopSound([{ name: "winShowerSound" }]);
                var myArray = ["reelSpinSound"];

                var randomItem = myArray[Math.floor(Math.random() * myArray.length)];
                let sound;
                if (this.props.basegamestate) {
                    sound = "bgloop";
                }
                else if (!this.props.basegamestate) {
                    sound = "fgloop";
                }
                nextProps.bgSoundPlay && this.props.changeVolume([{ name: sound, vol: 0.2 }]);
                this.props.playSound([{ name: randomItem, loop: true }]);
                // this.props.playSound([{ name: randomItem, loop: true }, { name: sound, vol: 0.1 }]);

                this.spinSound = randomItem;


            }

            if (nextProps.soundIsPlaying && nextProps.soundIsPlaying != this.props.soundIsPlaying) {
                if (nextProps.basegamestate) {
                    // DO not play loop from here play it from sound popup yes button click
                    nextProps.bgSoundPlay && this.props.playSound([{ name: "bgloop", loop: true }]);
                } else {
                    this.props.playSound([{ name: "demoSpinSound", loop: false }]);
                    nextProps.bgSoundPlay && this.props.playSound([{ name: "fgloop", loop: true }]);
                }

                return false;
            }

            if (!nextProps.allSoundSFXStop) {
                this.spinSound && this.props.stopSound([{ name: this.spinSound }]);
                if (nextProps.blastStart && nextProps.blastStart != this.props.blastStart) {
                    nextProps.blastSymbolSoundArr.forEach((symId: any, index: any) => {
                        let soundId: any
                        if (symId < 2) {
                            soundId = 1
                        } else if (symId > 1 && symId < 6) {
                            soundId = 2
                        } else if (symId > 5 && symId < 10) {
                            soundId = symId
                        }
                        soundId = "symbol_" + soundId;
                        let timer = TIMER.TimerManager.createTimer(200);
                        timer.on('end', () => {
                            this.props.playSound([{ name: soundId, loop: false }]);
                        });
                        timer.start();
                        let timer1 = TIMER.TimerManager.createTimer(1800);
                        timer1.on('end', () => {
                            this.props.playSound([{ name: "symbol_blast", loop: false }]);

                            let timerdrop = TIMER.TimerManager.createTimer(600);
                            timerdrop.on('end', () => {
                                this.props.playSound([{ name: "tumbleSound", loop: false }]);
                            });
                            timerdrop.start();
                        });
                        timer1.start();
                    })

                }

                if (nextProps.spinStopID > -1 && nextProps.spinStopID != this.props.spinStopID) {
                    let soundPlaylist: any = [{ name: "reelStoppingSound", loop: false, vol: 1 }]
                    if (nextProps.landingAnimPositions.length > 0) {


                        for (let i = 0; i < nextProps.landingAnimPositions.length; i++) {
                            if (nextProps.spinStopID == nextProps.landingAnimPositions[i].reelId) {
                                soundPlaylist = [];
                                this.playScatterLandingCount++;
                                if (this.playScatterLandingCount > 4) {
                                    this.playScatterLandingCount = 4;
                                }
                                this.props.stopSound([{ name: "scatterLanding" + this.playScatterLandingCount }]);

                                //this.props.playSound([{ name: "scatterLanding" + this.playScatterLandingCount, loop: false, vol: 0.7 }]);
                                soundPlaylist.push({ name: "scatterLanding" + this.playScatterLandingCount, loop: false, vol: 0.6 });
                            }
                        }
                    }





                    this.props.stopSound([{ name: "reelStoppingSound" }]);
                    //console.log("--YAHOO playSound spinStopID : --", nextProps.spinStopID, soundPlaylist);

                    this.props.playSound(soundPlaylist);

                }
                if (nextProps.featureJustTriggered && nextProps.featureJustTriggered != this.props.featureJustTriggered) {
                    // this.props.playSound([{ name: "introLoop", loop: false, vol: 0.7 }]);


                    nextProps.bgSoundPlay && this.props.playSound([{ name: "fgloop", loop: true, vol: 0.1 }, { name: "introLoop", loop: false, vol: 0.7 }]);
                    this.props.stopSound([{ name: "bgloop" }]);
                }
                if (nextProps.featureJustFinished && nextProps.featureJustFinished != this.props.featureJustFinished) {
                    // this.props.playSound([{ name: "fgOutroSound", loop: false, vol: 0.7 }, { name: "fgloop", vol: 0.1 }]);
                    // this.props.stopSound([{ name: "bgloop" }]);
                }
                if (nextProps.spinButtonClicked && nextProps.spinButtonClicked != this.props.spinButtonClicked) {
                    this.props.playSound([{ name: "spinButtonSound", loop: false }]);
                    this.props.setApplicationSpinButtonClicked(false);
                    return false;
                }

                if (nextProps.basegamestate && nextProps.basegamestate != this.props.basegamestate) {
                    this.props.stopSound([{ name: "bgloop" }]);

                    return false;
                }

                if (!nextProps.basegamestate && nextProps.basegamestate != this.props.basegamestate) {
                    this.props.stopSound([{ name: "introLoop" }]);
                    let timer = TIMER.TimerManager.createTimer(400);
                    timer.on('end', () => {
                        this.props.playSound([{ name: "demoSpinSound", loop: false }]);
                    });
                    timer.start(false, 400);
                    return false;
                }
                if (nextProps.spinStopID > -1 && nextProps.spinStopID != this.props.spinStopID) {
                    this.playSound(nextProps.spinStopID, nextProps);
                    return false;
                }

                if (nextProps.buttonClickedSound && nextProps.buttonClickedSound != this.props.buttonClickedSound) {
                    this.onButtonClickSound();
                    return false;
                }

                if (nextProps.showLockedReel && nextProps.showLockedReel !== this.props.showLockedReel) {
                    //this.lockedReelComponentList = nextProps.lockedReelArr;
                    this.props.playSound([{ name: "lockedReelSound", loop: false }]);
                }

            }


            // other than bg sounds


        } else {
            this.spinSound && this.props.stopSound([{ name: this.spinSound }]);
        }

        return false;
    }


    render() {

        return (<></>)
    }
}

export default withPixiApp(connect(
    (state: Pick<IStore, 'gameLevelSoundState' | 'introductionState' | 'lockedReelState' | 'landingState' | 'behaviourState' | 'soundState' | 'gridsState' | 'asyncInitAction' | 'freegameState' | 'basegameState' | 'buttonPanelState'>): IStateToProps =>
    ({
        soundIsPlaying: state.soundState.soundIsPlaying,
        soundLoadStart: state.soundState.soundLoadStart,
        blastStart: state.gridsState.blastStart,
        stoppedReel: state.gridsState.stoppedReel,
        isInitResponseReceived: state.asyncInitAction.isInitResponseReceived,
        featureJustFinished: state.freegameState.featureJustFinished,
        basegamestate: state.basegameState.basegamestate,
        spinStopID: state.gridsState.spinStopID,
        spinStart: state.gridsState.spinStart,
        buttonClickedSound: state.buttonPanelState.buttonClickedSound,
        spinButtonClicked: state.buttonPanelState.spinButtonClicked,
        showIntroductionPage: state.introductionState.showIntroductionPage,
        allSpinComplete: state.gridsState.allSpinComplete,
        featureTriggered: state.behaviourState.featureTriggered,
        landingSymbolSoundArr: state.behaviourState.landingSymbolSoundArr,
        blastSymbolSoundArr: state.behaviourState.blastSymbolSoundArr,
        landingAnimPositions: state.landingState.landingAnimPositions,
        showLockedReel: state.lockedReelState.showLockedReel,
        featureJustTriggered: state.basegameState.featureJustTriggered,
        bgSoundPlay: state.gameLevelSoundState.bgSoundPlay,
        allSoundSFXStop: state.soundState.allSoundSFXStop,
        introductionScreenVisible: state.introductionState.introductionScreenVisible,
        //  effectSoundPlay: state.gameLevelSoundState.effectSoundPlay,



    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),
        setStoppedReel: (stoppedReel: number): any => dispatch(gridActions.setStoppingReel(stoppedReel)),
        stopSound: (soundName: any): any => dispatch(soundActions.stopSound(soundName)),
        playingSound: (soundIsPlaying: any): any => dispatch(soundActions.playingSound(soundIsPlaying)),
        setApplicationSpinButtonClicked: (isClicked: boolean): any => dispatch(buttonActions.setApplicationSpinButtonClicked(isClicked)),
        changeVolume: (soundObject: any): any => dispatch(soundActions.changeVolume(soundObject)),
    }))(GAMESounds));